import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

/**
 * docs/DESIGN_SYSTEM.md §4.2 — one step darker than the surrounding card
 * so it reads as a "hole" to type into, matching Discord's own treatment.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error, ...props }, ref) => {
    return (
      <div>
        <input
          ref={ref}
          className={[
            'h-9 w-full rounded-sm bg-bg-base border px-3 text-body text-text-primary placeholder:text-text-tertiary',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-management-500',
            error ? 'border-danger' : 'border-border-subtle focus:border-border-strong',
            className,
          ].join(' ')}
          {...props}
        />
        {error ? <p className="text-small text-danger mt-1">{error}</p> : null}
      </div>
    );
  },
);

Input.displayName = 'Input';
